export default __webpack_public_path__ + "static/Brooklyn-013a8698ff479f14ca6cf8fceba61c8c.svg";